/**
 * 홈 화면 공지사항 목록 조회. 무인증 비동기 함수(SWR 훅이 아니다).
 * `GET /app/board/main`
 *
 * @returns 응답 전체(`FetchBoardMainResponse`) 또는 실패 시 null.
 */
import publicApi from "pages/api/axiosPublic";

export interface BoardItem {
  boardId: number;
  title: string;
  createdAt: string;
}

interface FetchBoardMainResponse {
  isSuccess: boolean;
  code: number;
  message: string;
  result: BoardItem[];
}

export const useGetNotices =
  async (): Promise<FetchBoardMainResponse | null> => {
    try {
      const response = await publicApi.get<FetchBoardMainResponse>(
        "/app/board/main"
      );
      return response.data;
    } catch (error) {
      console.error("공지사항 목록 가져오기 오류:", error);
      return null;
    }
  };
